var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.427,
    height: 20.102,
    viewBox: "6355.287 17564.951 19.427 20.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Logout \\u2013 5"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3185"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 15633"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6372.474 17571.957h-.001a.547.547 0 0 0-.547.549v.714c0 2.715 0 4.354-.491 5.108-.401.614-1.244.812-3.608.846h-.242l-.108-.002 1.12-1.965a2.083 2.083 0 0 0-.693-2.854 2.084 2.084 0 0 0-2.863.693c-.49.813-1.056 1.453-1.467 1.768-.087-.881-.087-2.072-.087-3.594 0-2.625 0-4.21.429-5.003.35-.646 1.08-.874 3.004-.936a.548.548 0 0 0-.018-1.095h-.018c-2.056.067-3.292.327-3.931 1.509-.49.905-.552 2.233-.56 4.477a6.336 6.336 0 0 0-1.387.019c-1.49.19-2.632.93-3.301 2.142a378.797 378.797 0 0 1-2.296 4.1.548.548 0 0 0 .95.543c.01-.016.894-1.566 2.304-4.113.496-.898 1.32-1.43 2.45-1.582.508-.068.97-.042 1.279-.007 0 1.632 0 2.826.102 3.751h-.86a.548.548 0 0 0 0 1.095h1.444a.54.54 0 0 0 .123-.002c.585-.027 1.216-.458 1.93-1.319.484-.586.834-1.165.847-1.186a.987.987 0 0 1 1.68 1.03l-1.522 2.672a.541.541 0 0 0-.129.226l-.304.535-.01.02c-1.398 2.694-5.722 3.813-5.78 3.827a.547.547 0 0 0 .266 1.062c.197-.049 4.848-1.243 6.48-4.375l.204-.357c.215.007.45.013.713.017h.264c2.15-.031 3.733-.145 4.513-1.343.67-1.027.67-2.688.67-5.706v-.716a.547.547 0 0 0-.548-.546Z",
    fill: "#fd6036",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.639 100.782h-.001a.547.547 0 0 0-.547.548v.714c0 2.715 0 4.354-.491 5.108-.401.615-1.244.812-3.608.846h-.241l-.109-.001 1.12-1.966a2.083 2.083 0 0 0-.693-2.853 2.084 2.084 0 0 0-2.863.692c-.49.813-1.056 1.453-1.467 1.768-.087-.88-.087-2.072-.087-3.594 0-2.625 0-4.21.429-5.003.35-.646 1.08-.873 3.004-.936a.548.548 0 0 0-.018-1.095h-.018c-2.056.067-3.292.327-3.931 1.509-.49.905-.552 2.233-.56 4.477a6.336 6.336 0 0 0-1.387.019c-1.49.19-2.632.93-3.301 2.142a378.797 378.797 0 0 1-2.296 4.1.548.548 0 0 0 .95.543c.01-.015.894-1.566 2.304-4.113.496-.898 1.32-1.43 2.45-1.581.508-.069.97-.043 1.279-.008 0 1.632 0 2.826.103 3.752h-.862a.548.548 0 0 0 0 1.095h1.445a.54.54 0 0 0 .123-.003c.585-.027 1.216-.458 1.93-1.319.484-.586.834-1.165.847-1.185a.987.987 0 0 1 1.68 1.03l-1.522 2.671a.541.541 0 0 0-.128.227l-.305.534-.01.02c-1.398 2.694-5.722 3.813-5.78 3.827a.547.547 0 0 0 .266 1.063c.197-.05 4.848-1.244 6.48-4.376l.204-.357c.215.007.45.013.713.017h.264c2.15-.03 3.733-.145 4.513-1.343.67-1.026.67-2.688.67-5.706v-.715a.547.547 0 0 0-.548-.547Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    stroke: "#fd6036",
    fill: "transparent",
    transform: "matrix(1.00565 0 0 1.00531 6275.335 17470.62)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 15634"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6374.663 17569.92a5.283 5.283 0 0 0-4.905-4.918.547.547 0 1 0-.074 1.093 4.184 4.184 0 0 1 3.886 3.895c.018.29.26.512.546.512h.035c.302-.02.53-.28.512-.582Z",
    fill: "#fd6036",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.707 78.275a5.283 5.283 0 0 0-4.905-4.918.547.547 0 1 0-.074 1.093 4.184 4.184 0 0 1 3.886 3.895c.018.29.26.513.546.513l.035-.001c.302-.02.53-.28.511-.582Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    stroke: "#fd6036",
    fill: "transparent",
    transform: "matrix(1.01821 0 0 1.01818 6030.855 17490.261)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 15635"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6369.061 17568.536c1.138 0 2.063.926 2.063 2.064a.548.548 0 0 0 1.095 0 3.162 3.162 0 0 0-3.158-3.159.548.548 0 0 0 0 1.095Z",
    fill: "#fd6036",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.708 119.095c1.137 0 2.063.925 2.063 2.063a.548.548 0 0 0 1.095 0 3.162 3.162 0 0 0-3.158-3.158.548.548 0 0 0 0 1.095Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    stroke: "#fd6036",
    fill: "transparent",
    transform: "matrix(1.02698 0 0 1.02699 6039.664 17446.207)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentActive);
export default __webpack_public_path__ + "static/media/paymentActive.8225c0da540f226fd0ae9da8ffd7d5c5.svg";
export { ForwardRef as ReactComponent };